import { css } from "@emotion/react";

import { animations, colors } from "@styles";

export const linkStyling = css`
  ${animations.transition()};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export const noUnderline = css`
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`;

export const externalIcon = css`
  margin-left: 0.5rem;
`;

export const disabled = css`
  color: ${colors.grey.darkFamily.light};
  cursor: not-allowed;

  &:hover,
  &:focus,
  &:active {
    color: ${colors.grey.darkFamily.light};
  }
  &:hover {
    text-decoration: underline;
  }
`;

export const color = {
  primary: css`
    color: ${colors.green.base};

    &:hover {
      color: ${colors.green.darkFamily.light};
    }
    &:active {
      color: ${colors.green.darkFamily.darker};
    }
  `,
  info: css`
    color: ${colors.blue.base};

    &:hover,
    &:active {
      color: ${colors.blue.darkFamily.darker};
    }
  `,
  danger: css`
    color: ${colors.danger};

    &:hover {
      color: ${colors.red.darkFamily.light};
    }
    &:active {
      color: ${colors.red.darkFamily.darker};
    }
  `,
  warning: css`
    color: ${colors.warning};

    &:hover {
      color: ${colors.orange.darkFamily.light};
    }
    &:active {
      color: ${colors.orange.darkFamily.darker};
    }
  `,
  purple: css`
    color: ${colors.purple.base};

    &:hover {
      color: ${colors.purple.darkFamily.light};
    }
    &:active {
      color: ${colors.purple.darkFamily.darker};
    }
  `,
  dark: css`
    color: ${colors.grey.darkFamily.dark};

    &:hover,
    &:active {
      color: ${colors.green.base};
    }
  `,
  light: css`
    color: ${colors.white};

    &:hover {
      color: ${colors.white};
    }
    &:active {
      color: ${colors.grey.lightFamily.darker};
    }
  `,
};

export const noStyleButton = css`
  padding: 0;
`;
